module.exports = __webpack_public_path__ + "media/components/assets/sujung_09-f1dcb78c973fbda089f3d52843f185a3.png";